import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownRenderPipe } from 'src/app/@shared/pipes/markdown-render.pipe';

import { IToolCall } from 'src/app/features/general-agent/models/tool-call.model';

@Component({
    selector: 'app-generic-tool-view',
    standalone: true,
    imports: [CommonModule, MarkdownRenderPipe],
    templateUrl: './generic-tool-view.component.html',
    styleUrl: './generic-tool-view.component.scss'
})
export class GenericToolViewComponent {
    //#region Inputs
    toolCall = input<Partial<IToolCall>>({});
    //#endregion

    //#region Computed values
    formattedAssistantContent = computed(() => {
        const content = this.toolCall().assistantContent;
        return this.formatContent(content || null);
    });

    formattedToolContent = computed(() => {
        const content = this.toolCall().toolContent;
        return this.formatContent(content || null);
    });
    //#endregion

    //#region Methods
    private formatContent(content: string | null): string | null {
        if (!content) return null;

        try {
            const parsedJson = JSON.parse(content);         
            return JSON.stringify(parsedJson, null, 2);
        } catch (e) {
            if (content?.startsWith('COMPOSIO')) {
                content = content.replace('COMPOSIO', '');
            }
            return content;
        }
    }
    //#endregion
}
